'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002442 from "./presto.-Agent-View$$anon$42.js";
import * as $j_presto$002etypes$0024$002dBase64$002dString$0024 from "./presto.types$-Base64-String$.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$41() {
  this.azF = null;
  this.azD = null;
  this.azE = false;
  this.azB = null;
  this.azC = false;
  this.azG = false;
  this.azH = false;
  this.azF = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_AgentView$$anon$41 as $c_Lpresto_AgentView$$anon$41 };
$p = $c_Lpresto_AgentView$$anon$41.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$41;
/** @constructor */
function $h_Lpresto_AgentView$$anon$41() {
}
export { $h_Lpresto_AgentView$$anon$41 as $h_Lpresto_AgentView$$anon$41 };
$h_Lpresto_AgentView$$anon$41.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.azF;
});
$p.t = (function() {
  if ((!this.azE)) {
    this.azD = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("origin", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("chain", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("signedHashes", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.azE = true;
  }
  return this.azD;
});
$p.ae = (function() {
  if ((!this.azC)) {
    this.azB = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().p9(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dBase64$002dString$0024.$m_Lpresto_types$Base64String$().nN(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002442.$c_Lpresto_AgentView$$anon$42()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.azC = true;
  }
  return this.azB;
});
$p.w = (function() {
  if ((!this.azH)) {
    this.azG = false;
    this.azH = true;
  }
  return this.azG;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_AgentView$$anon$41 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$41, "presto.AgentView$$anon$41", ({
  E7: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$41 as $d_Lpresto_AgentView$$anon$41 };
//# sourceMappingURL=presto.-Agent-View$$anon$41.js.map
